<template>
  <q-img :src="dataUrl"></q-img>
</template>

<script>
import {loadImageToDataUrl} from "@/utils/imageUtils";

export default {
  props: {
    url: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dataUrl: null
    }
  },
  async created() {
    this.dataUrl = await loadImageToDataUrl(this.url ?? 'https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/oatas_default.png');
  }
}
</script>
